import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@wa/shared';
import { Cell, DataTable, Empty, Page, when } from '@/components/Primitives';

const STATUS: Record<number, { label: string; tone: string }> = {
  0: { label: 'running', tone: 'text-(--color-muted)' },
  1: { label: 'succeeded', tone: 'text-(--color-good)' },
  2: { label: 'failed', tone: 'text-(--color-bad)' },
};

export function JobsPage() {
  const jobs = useQuery({
    queryKey: ['admin', 'jobs'],
    queryFn: () => adminApi.jobs(50),
    refetchInterval: 30_000,
  });

  return (
    <Page
      title="Job runs"
      subtitle="Every recurring job records its outcome, so &ldquo;did maintenance run last night&rdquo; is a query rather than a log search."
    >
      <DataTable head={['Job', 'Status', 'Started', 'Duration', 'Items', 'Detail']}>
        {jobs.data?.map((j) => {
          const status = STATUS[j.status] ?? { label: String(j.status), tone: '' };
          return (
            <tr key={j.id}>
              <Cell mono nowrap>{j.jobName}</Cell>
              <Cell nowrap><span className={status.tone}>{status.label}</span></Cell>
              <Cell nowrap>{when(j.startedAt)}</Cell>
              <Cell nowrap>{j.durationMs === null ? '—' : `${j.durationMs} ms`}</Cell>
              <Cell>{j.itemsProcessed}</Cell>
              <Cell mono>{j.detail ?? '—'}</Cell>
            </tr>
          );
        })}
      </DataTable>
      {jobs.data?.length === 0 && <Empty>No job has run yet.</Empty>}
    </Page>
  );
}
